<template>
    <v-container style="padding-top: 80px">
        <v-card>
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'"> mdi-upload </v-icon>
                <p style="color: white;">Carga Masiva Walmart</p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="pa-5 pt-4">
                <br />
                <v-row>
                    <v-col md="6" offset-md="3">
                        <v-row>
                            <v-col cols="10" md="10">
                                <span style="color: black; text-align: center;">Nota:</span>
                                <div>Si necesita la plantilla, haga clic en el siguiente botón</div>
                            </v-col>
                            <v-col cols="2" md="2" style="display: grid; place-content: end;">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs" class="btnAbo" icon fab
                                            @click="DescargarTemplateWalmart()">
                                            <v-icon color="green" dark style="cursor: pointer !important" class="hover">
                                                mdi-microsoft-excel
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar template</span>
                                </v-tooltip>
                            </v-col>

                        </v-row>
                    </v-col>
                </v-row>
                <v-form id="CargaLayout" ref="form" v-model="valid" lazy-validation>
                    <v-row class="mb-6" style="margin-bottom: 0px !important; height: 100px;">
                        <v-col md="6" offset-md="3">
                            <span style="color: black; text-align: center;">Archivo:</span>
                            <v-file-input v-model="file" @change="onChange" color="deep-purple accent-4" :rules="rules"
                                prepend-icon="mdi-paperclip" outlined accept="., .xlsx" required
                                :disabled="disabledfile" name="file">
                                <template v-slot:selection="{ index, text }">
                                    <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>
                                        {{ text }}
                                    </v-chip>
                                    <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
                                        {{ file.length - 2 }} File(s)
                                    </span>
                                </template>
                            </v-file-input>
                        </v-col>
                    </v-row>
                    <br />
                </v-form>
            </v-card-text>
            <v-card-text class="pa-1 pt-4" v-if="show">
                <v-col md="8" offset-md="2">
                    <v-data-table :headers="headers" :items="datosErrores" no-data-text="No hay datos disponibles"
                        :items-per-page="20" loading-text="Loading... Please wait" class="elevation-1"
                        :style="{ float: 'none', margin: '0 auto', width: '100%' }" :footer-props="{
                            'items-per-page-options': [20, 50, 100],
                            'items-per-page-text': 'Registros por página'
                        }">
                    </v-data-table>
                </v-col>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center">
                    <v-btn class="ma-2" color="primary" title="Limpiar" @click="GuardarDatos()" :disabled="disabledbtn">
                        Guardar
                    </v-btn>
                    <v-btn class="ma-2" color="error" title="Limpiar" @click="reset()" :disabled="disabledbtn">
                        Limpiar
                    </v-btn>

                </v-row>
            </v-card-actions>
        </v-card>
        <v-card v-if="showReportes" class="mt-2">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Reportes</p>
                <v-spacer></v-spacer>
                <div v-if="loadingExcel == false">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-on="on" v-bind="attrs" class="btnAbo" icon fab @click="DescargarExcel()">
                                <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                    mdi-microsoft-excel
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Descargar Excel</span>
                    </v-tooltip>
                </div>
            </v-card-title>
            <v-card-text class="pa-1 pt-4">
                <v-col md="10" offset-md="1">
                    <v-data-table :headers="headersReportes" :items="reportes" no-data-text="No hay datos disponibles"
                        :items-per-page="20" loading-text="Cargando... Por favor espere" class="elevation-1"
                        :footer-props="{
                            'items-per-page-options': [20, 50, 100],
                            'items-per-page-text': 'Registros por página'
                        }">
                        <template v-slot:[`item.reporte`]="{ item }">
                            <a v-if="item.aiclave == 27 || item.aiclave == 26 || item.aiclave == 1 || item.aiclave == 24 || item.aiclave == 23 || item.aiclave == 5"
                                v-on:click="BuscarReporte(item);">{{ item.reporte }}</a>
                            <p v-else>{{ item.reporte }}</p>
                        </template>
                    </v-data-table>
                </v-col>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import * as XLSX from 'xlsx/xlsx.mjs';
import CargaMasiva from '@/services/CargaMasiva/CargaMasiva.service.js';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
import Archivos from '@/services/Archivos/Archivos.service.js';

export default {
    title() {
        return this.$route.meta.title
    },
    data() {
        return {
            permisoCarga: false,
            data: Array,
            disabledProducto: false,
            valid: true,
            file: null,
            rules: [
                v => {
                    if (v == null) {
                        return 'Archivo requerido'
                    }
                    else {
                        return true
                    }
                }
            ],
            disabledfile: false,
            disabledbtn: false,
            show: false,
            datosErrores: [],
            headers: [
                { text: 'Fila', value: 'fila', class: "text title" },
                { text: 'Observaciones', value: 'observaciones', class: "text title" }
            ],
            showReportes: false,
            headersReportes: [
                { text: 'Reporte', value: 'reporte', class: "text title" },
                { text: 'Siniestro', value: 'svnumsin', class: "text title" },
                { text: 'Conductor', value: 'svnomcond', class: "text title" },
                { text: 'Estado', value: 'esnombre', class: "text title" },
                { text: 'Localidad', value: 'lonombre', class: "text title" },
                { text: 'Producto', value: 'ptdesc', class: "text title" },
                { text: 'Fecha de Siniestro', value: 'svfhsiniestro', class: "text title" },
                { text: 'Observaciones', value: 'svconversa', class: "text title" },
                { text: 'Asignar', value: 'sunombre', class: "text title" },
            ],
            reportes: [],
            loadingExcel: false,
        }
    },
    computed: {
        ...mapGetters(['getUser', 'THEME_STATE']),
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage', 'permission']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    methods: {
        onChange(e) {
            this.disabledbtn = true;
            if (this.file != null) {
                if (this.file.size > 8500) {
                    var files = e, f = e;
                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = async function (e) {
                        var data = new Uint8Array(e.target.result);
                        var workbook = XLSX.read(data, { type: 'array' });
                        let sheetName = workbook.SheetNames[0];
                        let worksheet = workbook.Sheets[sheetName];

                        let datos = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                        const header = datos.shift().map(h => h.trim());

                        if (header[0] == "Reporte" && header[1] == "Siniestro" && header[2] == "Conductor" && header[3] == "Localidad"
                            && header[4] == "Estado" && header[5] == "Producto" && header[6] == "Fecha de siniestro" && header[7] == "Observaciones"
                            && header[8] == "Supervisor" && header[9] == "Abogado") {

                            let dat = XLSX.utils.sheet_to_json(worksheet);

                            // Función para limpiar las claves con espacios
                            dat = dat.map(row => {
                                let trimmedRow = {};
                                Object.keys(row).forEach(key => {
                                    const trimmedKey = key.trim(); // Aplicar trim() a las claves
                                    trimmedRow[trimmedKey] = row[key]; // Crear nuevo objeto con claves sin espacios
                                });
                                return trimmedRow;
                            });
                            if (dat.length > 0) {// Correcto para validar la información

                                vm.$swal({
                                    position: 'center',
                                    title: 'Validando Información, espere un momento....',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    didOpen: () => {
                                        vm.$swal.showLoading();
                                    }
                                });
                                vm.data = dat;
                                CargaMasiva.ValidarDatosExcelCivil(vm).then(response => {
                                    setTimeout(() => {
                                        vm.$swal.close();
                                        if (response.length > 0) {
                                            vm.show = true;
                                            vm.datosErrores = response;
                                            vm.disabledbtn = false;
                                            vm.$swal({
                                                position: 'center',
                                                icon: 'warning',
                                                title: 'Advertencia',
                                                text: 'Verifique los errores de la tabla para poder realizar la carga.',
                                                showConfirmButton: true,
                                                allowOutsideClick: false,
                                                allowEscapeKey: false
                                            })
                                        }
                                        else {
                                            vm.datosErrores = [];
                                            vm.show = false;
                                            vm.disabledbtn = false;
                                        }
                                    }, 1500);
                                });
                            }
                            else {
                                vm.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Formato Incorrecto',
                                    text: 'El archivo no cuenta con algún registro, favor de seleccionar otro',
                                    showConfirmButton: true,
                                    timer: 3000,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        vm.data = Array;
                                        vm.file = null;
                                        vm.reset();
                                        vm.disabledbtn = false;
                                    }
                                });
                                setTimeout(() => {
                                    vm.data = Array;
                                    vm.file = null;
                                    vm.reset();
                                    vm.disabledbtn = false;
                                }, 3000);
                            }
                        }
                        else {
                            vm.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Formato Incorrecto',
                                text: 'Seleccione otro archivo',
                                showConfirmButton: true,
                                timer: 3000,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    vm.data = Array;
                                    vm.file = null;
                                    vm.reset();
                                    vm.disabledbtn = false;
                                }
                            });
                            setTimeout(() => {
                                vm.data = Array;
                                vm.file = null;
                                vm.reset();
                                vm.disabledbtn = false;
                            }, 3000);
                        }
                    };
                    reader.readAsArrayBuffer(f);
                }
                else {
                    this.$swal({
                        position: 'center',
                        icon: 'error',
                        title: 'Formato Incorrecto',
                        text: 'Seleccione otro archivo',
                        showConfirmButton: true,
                        timer: 3000,
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.data = Array;
                            this.file = null;
                            this.reset();
                            this.disabledbtn = false;
                        }
                    });
                    setTimeout(() => {
                        this.data = Array;
                        this.file = null;
                        this.reset();
                        this.disabledbtn = false;
                    }, 3000);
                }
            }
            else {
                this.disabledbtn = false;
                this.data = Array;
                this.file = null;
                this.show = false;
                this.datosErrores = [];
            }
        },
        async GuardarDatos() {
            this.$refs.form.validate();
            this.disabledbtn = true;

            if (this.$refs.form.validate() && this.datosErrores.length == 0) {
                this.$swal({
                    position: 'center',
                    title: 'Guardando, espere un momento....',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });
                let response = await CargaMasiva.DatosExcelCivil(this);
                if (!response.error) {
                    if (response.data.length > 0) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se dieron de alta los reportes correctamente',
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 2500,
                        }).then((result) => {
                            this.reportes = response.data;
                            this.showReportes = true;
                            this.file = null;
                            this.$refs.form.reset();
                        })
                    }
                } else {
                    this.$swal({
                        position: 'center',
                        icon: 'error',
                        title: 'Error',
                        text: response.msg,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.reset();
                            this.disabledbtn = false;

                        }
                    })
                }

            } else {
                if (this.datosErrores.length > 0) {
                    this.$swal({
                        position: 'center',
                        icon: 'info',
                        title: 'Información',
                        text: 'Necesita corregir los errores que aparecen en la tabla para poder guardar los datos.',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.reset();
                            this.disabledbtn = false;

                        }
                    })
                }
            }
            this.disabledbtn = false;

        },
        reset() {
            this.disabledbtn = false;
            this.data = Array;
            this.file = null;
            this.disabledbtn = false;
            this.show = false;
            this.datosErrores = [];
            this.$refs.form.reset();
            this.disabledfile = false;
            this.showReportes = false;
        },
        async BuscarReporte(item) {
            let reporte = {
                nrreporte: item.nrreporte,
                svindice: item.svindice,
                aiclave: item.aiclave,
                svfhconclusion: item.svfhconclusion
            };

            if (item.aiclave != 26) {
                var ver = 0;
                let formData = new FormData();
                formData.append("nrreporte", item.nrreporte);
                formData.append("svindice", item.svindice);
                formData.append("uslogin", MetodosGenerales.ObtenerUserName());
                await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                    ver = data;
                });

                if (ver == 0) {
                    this.$router.push({ name: `${"DatosIncompletos"}` });
                }
                else {
                    await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                    let url = this.$router.resolve({ name: `${"Asistencias"}` });
                    window.open(url.href, '_blank');
                }
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                let url = this.$router.resolve({ name: `${"Asistencias"}` });
                window.open(url.href, '_blank');
            }
        },
        async DescargarExcel() {

            this.loadingExcel = true;
            let nrReportes = this.reportes.map(item => item.nrreporte).join(',');
            const response = await CargaMasiva.DescargarWalmart(this, nrReportes);
            let today = moment().format('yyyy-MM-DD');

            this.nombreArchivo = 'ReportesWalmart-' + today.toString();

            await MetodosGenerales.exportToExcel(response, this.nombreArchivo, false, false);

            this.loadingExcel = false;

            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'Carga Walmart');
            formData.append("laaccion", "Descargar Archivo excel");
            formData.append("lacaracteristicas", 'CargaWalmart');
            formData.append("lanombre", this.nombreArchivo + ".xlsx");
            formData.append("ladestinatario", " ");
            Archivos.AlmacenarVisitas(formData).then(data => {
            });

        },
        async DescargarTemplateWalmart() {
            let response = await CargaMasiva.DescargarTemplateWalmart(this)
            if (!response.error) {
                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Carga Walmart');
                formData.append("laaccion", "Descargo Plantilla");
                formData.append("lacaracteristicas", 'CargaWalmart');
                formData.append("lanombre", "CargaMasivaWalmart.xlsx");
                formData.append("ladestinatario", " ");
                Archivos.AlmacenarVisitas(formData).then(data => { });
                await MetodosGenerales.descargaArchivo(response.msg, 'CargaMasivaWalmart.xlsx', 'xlsx');

            }
        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '386').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 386)//Permiso para ver concluidos
                        this.permisoCarga = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
}
</script>